// Tracking minimum page "Remplacer mon tamis" (brief §7) — memes
// CustomEvent "hexagon:rmt-*" que les autres scripts de cette page
// (assets/rmt-simulateur.js, assets/rmt-form.js emettent deja sim-*/
// tamis-select). Complete ici : CTA demande, clic contact, ouverture FAQ,
// debut/erreur/succes du formulaire. Aucune donnee libre (message, photos)
// n'est transmise — uniquement des noms d'evenements.
//
// 2026-09-03 : trackEvent() relaie aussi vers window.HexagonAnalytics
// (Shopify.analytics.publish) — audit/mise en place analytics, brief dedie.
(function () {
  function trackEvent(name, detail) {
    var fullName = 'hexagon:rmt-' + name;
    document.dispatchEvent(new CustomEvent(fullName, { detail: detail || {} }));
    if (window.HexagonAnalytics) window.HexagonAnalytics.publish(fullName, detail);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.rmt-hero__actions .btn, .rmt-aide__actions .btn')) {
      trackEvent('cta-demande');
    }
    if (e.target.closest('[data-rmt-track="contact"]')) {
      trackEvent('cta-contact');
    }
    // Ce script n'est charge que sur cette page (voir templates/
    // page.remplacer-mon-tamis.json) : pas besoin de scoper a une section
    // FAQ precise, toute ouverture d'accordeon ici concerne cette page.
    if (e.target.closest('.faq-item__question')) {
      trackEvent('faq-open');
    }
  });

  var form = document.getElementById('RmtForm');
  if (form) {
    var firstField = form.querySelector('input, select, textarea');
    if (firstField) {
      firstField.addEventListener('focus', function () { trackEvent('form-start'); }, { once: true });
    }
    if (form.querySelector('.badge[style*="var(--color-error"]')) trackEvent('form-error');
    if (form.parentNode && form.parentNode.querySelector('.badge[style*="var(--color-success"]')) trackEvent('form-success');
  }
})();
